const checkHandleAvailabilityDebounced = debounce((context, handle) => checkHandleAvailable(context, handle));

export const state = () => ({
    handle: '',
    error: undefined,
    isValidating: false,
});

export const getters = {
    getHandle(state) {
        return state.handle;
    },
    getHandleError(state) {
        return state.error;
    },
    getIsHandleValidating(state) {
        return state.isValidating;
    },
};

export const mutations = {
    setHandle(state, handle) {
        state.handle = handle;
    },
    setHandleError(state, error) {
        state.error = error;
    },
    setHandleValidating(state, isValidating) {
        state.isValidating = isValidating;
    },
};

export const actions = {
    setHandle(context, { handle, skipValidation }) {
        context.commit('setHandle', handle);
        if (!skipValidation) {
            const error = validateHandle(handle);
            context.commit('setHandleError', error);
            if (!error) {
                context.commit('setHandleValidating', true);
                checkHandleAvailabilityDebounced(context, handle);
            }
        }
    },
};

async function checkHandleAvailable(context, handle) {
    try {
        if (!!handle) {
            const isAvailable = await context.dispatch(
                'authStore/isHandleAvailable',
                {
                    handle,
                },
                { root: true },
            );
            if (handle === context.getters['getHandle']) {
                await context.commit('setHandleError', validateHandle(handle, isAvailable));
            }
        }
        context.commit('setHandleValidating', false);
    } catch (error) {
        console.error(error);
        context.commit('setHandleError', 'auth.generic');
    }
}

function validateHandle(handle, isAvailable) {
    if (!handle) return undefined;
    switch (true) {
        case handle.length > 30 || handle.length < 3:
            return 'auth.handleShort';
        case isAvailable !== undefined && !isAvailable:
            return 'auth.handleExists';
        case !handle.match(/^[a-zA-Z0-9.]*$/) || // handle can only have letters, numbers and dot.
            !!handle.match(/\.{2,}/) || // handle cannot have two consecutive dots.
            !handle.match(/[a-zA-Z0-9]$/) || // handle has to end with letters or numbers.
            !handle.match(/^[a-zA-Z0-9]/): // handle has to start with letters or numbers.
            return 'auth.handleInvalid';
    }
}

function debounce(func, timeout = 300) {
    let timer;
    return (context, handle) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(context, handle);
        }, timeout);
    };
}
